export enum UserPasswordStatus{
  Unconfirmed = "UNCONFIRMED",
  Confirmed = "CONFIRMED",
  ExternalProvider = "EXTERNAL_PROVIDER",
  Archived = "ARCHIVED",
  Unknown = "UNKNOWN",
  ResetRequired = "RESET_REQUIRED",
  ForceChangePassword ="FORCE_CHANGE_PASSWORD"
}
